var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Img } from 'react-image';
var formatScrSet = function (srcSet, imageProps) {
    return Object.entries(srcSet)
        .map(function (_a) {
        var width = _a[0], src = _a[1];
        return "".concat(src, " ").concat(width);
    })
        .join(', ');
};
var Image = function (props) {
    var srcSetString = props.srcSet ? formatScrSet(props.srcSet, props) : undefined;
    return _jsx(Img, __assign({}, props, { srcSet: srcSetString, src: props.src }));
};
export default Image;
